import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Mail, Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { authAPI } from "../lib/api";

export default function Login() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmail = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Inserisci email e password");
    setLoading(true);
    try {
      const { user, token } = await authAPI.login({ email, password });
      loginWithToken(user, token);
      toast.success("Benvenuto in SAN MARINO MARKET!");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-black text-[#1d3d3a]">Accedi a SAN MARINO MARKET</h1>
          <p className="text-sm text-slate-500 mt-1">Il marketplace della Repubblica di San Marino</p>
        </div>

        <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
          <Button onClick={handleGoogle} variant="outline" className="w-full h-12 rounded-xl font-semibold border-2 mb-3" data-testid="google-login-button">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continua con Google
          </Button>

          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-200"/></div>
            <div className="relative flex justify-center"><span className="bg-white px-3 text-xs text-slate-500">oppure</span></div>
          </div>

          <form onSubmit={handleEmail} className="space-y-3">
            <div>
              <label className="text-xs font-bold text-slate-700 block mb-1.5">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="tu@email.com" className="pl-9 h-11"/>
              </div>
            </div>
            <div>
              <label className="text-xs font-bold text-slate-700 block mb-1.5">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"/>
                <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="••••••••" className="pl-9 h-11"/>
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#e86a24] hover:bg-[#c8561a] font-semibold">
              <LogIn className="w-4 h-4 mr-2"/>{loading ? "..." : "Accedi"}
            </Button>
          </form>

          <p className="text-center text-sm text-slate-600 mt-5">
            Non hai un account? <Link to="/scegli-account" className="text-[#e86a24] font-semibold hover:underline">Registrati</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
